import {
  useActiveWalletChain,
  useSwitchActiveWalletChain,
} from "thirdweb/react";
import { Container, Button } from 'react-bootstrap';
import { bsc } from "thirdweb/chains";
import { useEffect } from "react";


const TopHeading = () => {
  const switchChain = useSwitchActiveWalletChain();
  const chain = useActiveWalletChain();
  const isBsc = chain?.id === bsc.id;
  
  // Auto-switch to BSC if connected to wrong network
  useEffect(() => {
    if (chain && !isBsc) {
      switchChain(bsc).catch((error) => {
        console.log("Failed to switch to BSC:", error);
      });
    }
  }, [chain, isBsc, switchChain]);
  
  return (
    <Container className="m-t-1 container">
      <div className="container">
        <div className="t-a-c m-b-2">
          <div className="l-s-1 f-s-1_5 f-w-600 t-t-u m-b-1">
            Infinnity Capital Server
          </div>
          <div className="network-switch-wrapper">
            {!isBsc && chain && (
              <div style={{ 
                backgroundColor: '#fff3cd', 
                border: '1px solid #ffc107',
                padding: '10px',
                borderRadius: '5px',
                marginBottom: '10px',
                color: '#856404'
              }}>
                ⚠️ Wrong Network Detected. Please switch to BSC Mainnet.
              </div>
            )}
            {/* <div className="active-network-readout m-t-0_5">
              <span className="label">Current Network:</span>
              <span className="value" style={{ color: isBsc ? 'green' : 'red' }}>
                {chain?.name || "Not Connected"}
                {isBsc && " ✓"}
              </span>
            </div> */}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default TopHeading;
